import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import { reducer as oidc } from 'redux-oidc'
import user from './user'
import userResources from './resources'
import preloader from './preloader'
import activeResource from './activeResource'

const createRootReducer = (history: any) =>
  combineReducers({
    router: connectRouter(history),
    oidc,
    user,
    userResources,
    preloader,
    activeResource
  })

export default createRootReducer
